export const validate = (input = "", regex = /^.*$/) => {
  return regex.test(input);
};
export const numberRegex = /^\d+$/;
export const decimalRegex = /^\d+\.{0,1}\d{0,2}$/;
export const fourDpRegex = /^\d+\.{0,1}\d{0,4}$/; // upto 4 decimal points
export const phoneNumRegex =
  /^03[0-9]{2}(?!1234567)(?!1111111)(?!7654321)[0-9]{7}$/;
